import React, { useRef } from "react";
import ButtonBase from "@mui/material/ButtonBase";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import PictureAsPdfRounded from "@mui/icons-material/PictureAsPdfRounded";
import AttachFileRounded from "@mui/icons-material/AttachFileRounded";
import DeleteOutlineRounded from "@mui/icons-material/DeleteOutlineRounded";
import CheckCircleOutlineRounded from "@mui/icons-material/CheckCircleOutlineRounded";
import SendRounded from "@mui/icons-material/SendRounded";
import { BotaoVoltar } from "../../../componentes/comuns/CabecalhoPaginaSecundaria";
import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
import AccountBalanceRounded from "@mui/icons-material/AccountBalanceRounded";
import SchoolRounded from "@mui/icons-material/SchoolRounded";
import FolderCopyRounded from "@mui/icons-material/FolderCopyRounded";
import ModelosProcesso from "./ModelosProcesso";
import { ajustarTamanhoFonteEscola, coresTextosGlobais, tamanhosPaginasAdministrativas, tamanhosControlesGlobais } from "../../../estilos/global";

const azul = "var(--sear-azul, #087cf0)";
const verde = "var(--sear-sucesso-texto, #188566)";
const texto = "var(--sear-texto, #244c7c)";
const secundario = "var(--sear-texto-secundario, #6d849e)";
const borda = "var(--sear-borda, #d7e7f7)";
const botaoPrincipal = {
  textTransform: "none", boxShadow: "none", minHeight: 36,
  fontSize: ajustarTamanhoFonteEscola("0.82rem"),
  backgroundColor: "var(--sear-acao-azul, #087cf0)", color: "#fff",
  "&:hover": { backgroundColor: "var(--sear-acao-azul-hover, #0669ce)", boxShadow: "none" },
};


function ItemResumo({ Icone, rotulo, valor, separador = false }) {
  return <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, px: { xs: 0, sm: 1.5 },
    borderLeft: { xs: "none", sm: separador ? `1px solid ${borda}` : "none" },
    borderTop: { xs: separador ? `1px solid ${borda}` : "none", sm: "none" }, pt: { xs: separador ? 0.8 : 0, sm: 0 } }}>
    <Icone sx={{ color: azul, fontSize: 25, flexShrink: 0 }} />
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontSize: ajustarTamanhoFonteEscola("0.75rem"), color: secundario, lineHeight: 1.35 }}>{rotulo}</Typography>
      <Typography sx={{ fontSize: ajustarTamanhoFonteEscola("0.8125rem"), color: texto, fontWeight: 700, lineHeight: 1.4, overflowWrap: "anywhere" }}>{valor}</Typography>
    </Box>
  </Box>;
}

export default function FormularioDocumentosProcesso({
  solicitacao, documents, uploadedDocs, documentsLoaded, erroDocumentos = false, processType,
  isChecking, isSubmitting, isConfirmed, allDocumentsUploaded,
  onVerify, onReload, onUpload, onRemove, onConfirmar, onRegister, onReturn,
}) {
  const entradasArquivo = useRef({});
  const anexados = documents.filter((doc) => uploadedDocs[doc.id]?.uploaded).length;
  const completo = documentsLoaded && documents.length > 0 && anexados === documents.length;
  const ocupado = isSubmitting || isChecking;
  const categoria = solicitacao?.tipoInstituicao === "escola" ? "Escola"
    : solicitacao?.tipoInstituicao === "mantenedora" ? "Mantenedora" : null;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0, gap: 0.75 }}>
      <Box component="header" sx={{ position: "relative", overflow: "hidden", display: "flex", alignItems: "center", gap: 1.4,
        mb: 0.75, flexShrink: 0 }}>
        <BotaoVoltar onClick={onReturn} rotulo="Voltar ao novo processo" disabled={ocupado} />
        <Box sx={{ minWidth: 0, pr: { xs: 0, sm: 15 }, position: "relative", zIndex: 1 }}>
          <Typography component="h1" sx={{ fontSize: tamanhosPaginasAdministrativas.tituloPagina, fontWeight: 700, color: coresTextosGlobais.tituloPagina, lineHeight: 1.15 }}>
            Documentos do Novo Processo
          </Typography>
          <Typography sx={{ mt: 0.3, fontSize: tamanhosControlesGlobais.descricao, color: secundario, lineHeight: 1.5 }}>
            Anexe os documentos necessários para registrar o processo.
          </Typography>
        </Box>
        <Box aria-hidden="true" sx={{ position: "absolute", right: 10, bottom: 0, width: 80, height: 48, display: { xs: "none", sm: "block" } }}>
          <Box sx={{ position: "absolute", right: 0, bottom: 0, width: 170, height: 102, transform: "scale(0.47)", transformOrigin: "bottom right" }}>
          <Box sx={{ position: "absolute", right: -10, bottom: 8, width: 160, height: 65, borderRadius: "80% 0 80% 0", bgcolor: "#b8dcfb", transform: "rotate(-15deg)", opacity: 0.45 }} />
          <Box sx={{ position: "absolute", left: 5, bottom: 0, width: 24, height: 92, borderRadius: "90% 10% 90% 10%", bgcolor: "#acd6f9", transform: "rotate(-36deg)", opacity: 0.5 }} />
          <DescriptionRounded sx={{ position: "absolute", left: 45, top: 2, fontSize: 99, color: "#f6fbff", filter: "drop-shadow(0 1px 1px #c8e2fb)" }} />
          <Box sx={{ position: "absolute", right: 10, bottom: 15, width: 42, height: 42, borderRadius: "50%", bgcolor: "#5daaff", color: "#fff", display: "grid", placeItems: "center" }}>
            <AttachFileRounded sx={{ fontSize: 28 }} />
          </Box>
          </Box>
        </Box>
      </Box>
      <Box component="section" aria-label="Resumo do processo" sx={{ borderRadius: 1.5, bgcolor: "var(--sear-superficie-azul, #edf7ff)", px: 1.5, py: 0.5, flexShrink: 0 }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1.15fr" }, gap: { xs: 0.8, sm: 0 } }}>
          <ItemResumo Icone={AccountBalanceRounded} rotulo="Mantenedora" valor={solicitacao?.nomeMantenedora || "Mantenedora não informada"} />
          <ItemResumo Icone={categoria === "Escola" ? SchoolRounded : AccountBalanceRounded}
            rotulo={`Instituição do processo${categoria ? ` · ${categoria}` : ""}`}
            valor={(categoria === "Escola" ? solicitacao?.nomeEscola : categoria === "Mantenedora" ? solicitacao?.nomeMantenedora : null) || "Instituição não informada"} separador />
          <ItemResumo Icone={FolderCopyRounded} rotulo="Tipo do processo" valor={solicitacao?.nomeProcesso || "Processo selecionado na etapa anterior"} separador />
        </Box>
      </Box>
      <ModelosProcesso disabled={ocupado || !processType} />
      {solicitacao?.envioIniciado && (
        <Alert severity="info" sx={{ flexShrink: 0, py: 0 }} action={<Button color="inherit" disabled={ocupado} onClick={onVerify}>Verificar resultado</Button>}>
          {isChecking ? "Consultando o resultado anterior..." : "Se uma tentativa perdeu a resposta, verifique o resultado ou reenvie os documentos. Outros processos podem ser iniciados ao voltar."}
        </Alert>
      )}
      {erroDocumentos && processType && !isChecking && (
        <Box sx={{ flexShrink: 0 }}><Button onClick={onReload} size="small">Recarregar documentos</Button></Box>
      )}
      <Paper component="section" aria-label="Documentos e confirmação" elevation={0}
        sx={{ px: { xs: 1, md: 1.75 }, pt: 0.5, pb: 0.75, display: "flex", flexDirection: "column", gap: 0.75,
          flex: "1 1 0", minHeight: 180, border: `1px solid ${borda}`, borderRadius: 1.5, boxShadow: "none" }}>
      <Box sx={{ flexShrink: 0, px: 0.25 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 0.65 }}>
          <Typography component="h2" sx={{ color: texto, fontWeight: 700, fontSize: ajustarTamanhoFonteEscola("0.88rem") }}>Documentos exigidos</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, mt: 0, color: secundario }}>
          <PictureAsPdfRounded sx={{ fontSize: 16, color: azul }} />
          <Typography sx={{ fontSize: ajustarTamanhoFonteEscola("0.74rem") }}>Anexe apenas arquivos PDF.</Typography>
        </Box>
          <Typography aria-live="polite" sx={{ color: completo ? verde : azul, display: "inline-flex", alignItems: "center", gap: 0.5, fontWeight: 600, fontSize: ajustarTamanhoFonteEscola("0.75rem") }}>
            {completo && <CheckCircleOutlineRounded aria-hidden="true" sx={{ fontSize: 16 }} />}
            {documentsLoaded ? `${anexados} de ${documents.length} anexados${completo ? " · Completo" : ""}` : "Carregando documentos..."}
          </Typography>
        </Box>
        <LinearProgress variant="determinate"
          value={documents.length ? anexados / documents.length * 100 : documentsLoaded ? 100 : 0}
          aria-label="Progresso dos anexos" sx={{ height: 5, borderRadius: 3, bgcolor: "var(--sear-superficie-azul, #e7f2ff)", "& .MuiLinearProgress-bar": { bgcolor: completo ? verde : azul } }} />
      </Box>
      <Box component="ol" aria-label="Lista de documentos exigidos" data-rolagem-conteudo=""
        sx={{ listStyle: "none", m: 0, p: 0, display: "flex", flexDirection: "column", gap: 0,
          border: `1px solid ${borda}`, borderRadius: 1.5,
          flex: "1 1 0", minHeight: 80, maxHeight: { xs: 360, md: "none" }, overflowY: "auto", pr: 0.25,
          scrollbarGutter: "stable", overscrollBehavior: "contain" }}>
        {documents.map((doc) => {
          const arquivo = uploadedDocs[doc.id];
          return (
            <Paper key={doc.id} component="li" elevation={0} sx={{ px: 1.25, py: 0.5,
              border: 0, borderBottom: `1px solid ${borda}`, borderRadius: 0, boxShadow: "none", flexShrink: 0,
              "&:last-child": { borderBottom: 0 }, "&:nth-of-type(even)": { bgcolor: "var(--sear-superficie-suave, #fcfdff)" }, bgcolor: "var(--sear-superficie, #fff)" }}>
              <Box sx={{ display: "grid", gap: { xs: 0.5, sm: 1.2 }, alignItems: "center", minHeight: 32,
                gridTemplateColumns: { xs: "minmax(0, 1fr) auto", sm: "minmax(0, 1fr) minmax(115px, 0.3fr) auto" } }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.1, minWidth: 0 }}>
                  <Box sx={{ width: 28, height: 28, borderRadius: 1, bgcolor: "var(--sear-superficie-azul, #e8f4ff)", color: azul, display: "grid", placeItems: "center", flexShrink: 0 }}>
                    <DescriptionRounded sx={{ fontSize: 23 }} />
                  </Box>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography component="h3" sx={{ color: texto, fontWeight: 700, lineHeight: 1.4,
                      fontSize: ajustarTamanhoFonteEscola("0.8125rem"), overflowWrap: "anywhere" }}>{doc.nome}</Typography>
                    {doc.descricao && <Typography sx={{ color: secundario, lineHeight: 1.4, mt: 0.25,
                      fontSize: ajustarTamanhoFonteEscola("0.75rem"), whiteSpace: "pre-line", overflowWrap: "anywhere" }}>{doc.descricao}</Typography>}
                  </Box>
                </Box>
                <Box sx={{ minWidth: 0, gridColumn: { xs: 1, sm: "auto" }, gridRow: { xs: 2, sm: "auto" } }}>
                  {arquivo?.uploaded ? (
                      <Box sx={{ display: "flex", minWidth: 0 }}>
                        <ButtonBase type="button" disabled={ocupado}
                          aria-label={`Substituir arquivo ${arquivo.name} de ${doc.nome}`}
                          onClick={() => entradasArquivo.current[doc.id]?.click()}
                          sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 0.5, color: azul, minWidth: 0, maxWidth: "100%", textAlign: "left", borderRadius: 0.5,
                            "&.Mui-focusVisible": { outline: `1px solid ${azul}`, outlineOffset: 2 },
                            "&.Mui-disabled": { color: secundario } }}>
                          <CheckCircleOutlineRounded sx={{ fontSize: 16, flexShrink: 0 }} />
                          <Typography component="span" noWrap sx={{ fontSize: ajustarTamanhoFonteEscola("0.73rem"), minWidth: 0 }}>{arquivo.name}</Typography>
                        </ButtonBase>
                      </Box>
                  ) : <Typography sx={{ color: secundario, fontSize: ajustarTamanhoFonteEscola("0.73rem") }}>Pendente</Typography>}
                </Box>
                <Box sx={{ flexShrink: 0, gridColumn: { xs: 2, sm: "auto" }, gridRow: { xs: "1 / span 2", sm: "auto" } }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                    <Button component="label" variant="outlined" disabled={ocupado} aria-label={`Anexar ${doc.nome}`}
                      startIcon={<AttachFileRounded sx={{ fontSize: 16 }} />} sx={{ textTransform: "none", fontSize: ajustarTamanhoFonteEscola("0.75rem"),
                        color: azul, borderColor: borda, minHeight: 32, px: 1, py: 0.3,
                        "&:hover": { bgcolor: "var(--sear-superficie-azul, #eaf4ff)", borderColor: azul } }}>
                      {arquivo?.uploaded ? "Substituir" : "Anexar PDF"}
                      <input id={`file-input-${doc.id}`} ref={(elemento) => { entradasArquivo.current[doc.id] = elemento; }} type="file" hidden disabled={ocupado}
                        onChange={(event) => { onUpload(doc.id, event); event.target.value = ""; }} accept="application/pdf" />
                    </Button>
                    {arquivo?.uploaded && <Tooltip title="Remover arquivo" arrow><span><IconButton aria-label={`Remover arquivo de ${doc.nome}`}
                      onClick={() => onRemove(doc.id)} disabled={ocupado} size="small"
                      sx={{ color: "var(--sear-erro-texto, #d32f2f)", borderRadius: 1 }}>
                      <DeleteOutlineRounded fontSize="small" />
                    </IconButton></span></Tooltip>}
                  </Box>
                </Box>
              </Box>
            </Paper>
          );
        })}
        {documentsLoaded && documents.length === 0 && <Typography sx={{ p: 1, color: secundario, fontSize: ajustarTamanhoFonteEscola("0.8rem") }}>Este processo não exige anexos. Confirme as informações para registrar.</Typography>}
      </Box>
      <Paper component="section" aria-label="Confirmação e registro do processo" variant="outlined"
        sx={{ pt: 0.5, border: 0, borderRadius: 0, boxShadow: "none", flexShrink: 0,
          display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 0.75,
          alignItems: { xs: "stretch", md: "center" }, justifyContent: "space-between",
          bgcolor: "var(--sear-superficie, #fff)" }}>
        <FormControlLabel control={<Checkbox checked={isConfirmed} disabled={ocupado} onChange={onConfirmar} size="small" sx={{ color: azul, p: 0.5 }} />}
          label="Confirmo que as informações fornecidas estão corretas."
          sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: ajustarTamanhoFonteEscola("0.8rem"), color: texto } }} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1, flexShrink: 0 }}>
          <Button variant="contained" onClick={onRegister}
            disabled={!solicitacao || !allDocumentsUploaded || !isConfirmed || isSubmitting || isChecking}
            startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : <SendRounded />}
            sx={botaoPrincipal}>{isSubmitting ? "Registrando..." : "Registrar Processo"}</Button>
        </Box>
      </Paper>
      </Paper>
    </Box>
  );
}
